
  import {defineComponent} from 'vue';
  import router from "@/router";
  import api from "@/api/backend-api";
  import paycoUtils from "@/assets/js/utils";
  import {NamedRouting} from "@/domain/utils/NamedRouting";
  import HeaderComponent from "@/components/shared/HeaderComponent.vue";
  import {mapGetters} from "vuex";
  export default defineComponent({
    name: 'PromotionDetailView',
    components: {
      HeaderComponent,
    },
    props: [
        'bannerId'
    ],
    data() {
      return {
        promotionDetailImageUrl: '' as string,
        productId: 0 as number,
        showButton: true as boolean,
      }
    },
    computed: {
      ...mapGetters('AppYnStore', [
        'isApp'
      ]),
    },
    mounted() {
      api.getPromotionBannerById(this.bannerId)
      .then(response => {
        this.promotionDetailImageUrl = response.data.result.detailImageUrl;
        this.productId = response.data.result.productId;
        this.showButton = paycoUtils.convertYnToBoolean(response.data.result.buttonYn);
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    methods: {
      moveToProductDetail() {
        router.push(new NamedRouting('ProductDetailView', {productId: this.productId}));
      }
    }
  })
  ;


